(function () {
  const PENDING_MARKET_KEY = 'ipPendingMarket';

  function blockCanadaCommercePages() {
    if (!document.body.classList.contains('market-canada')) return;

    const path = window.location.pathname;
    const blocked = /(^|\/)(cart|account)(\/|$)/.test(path);

    if (blocked) {
      window.location.replace('/');
    }
  }

  function submitLocalization(formId, returnTo) {
    const form = document.getElementById(formId);
    if (!form) return;

    if (returnTo) {
      const returnInput = form.querySelector('[name="return_to"]');
      if (returnInput) returnInput.value = returnTo;
    }

    form.submit();
  }

  function redirectMarketLanguage(root, value) {
    const current = root.dataset.current;
    if (value === current) return;

    const path = window.location.pathname + window.location.search + window.location.hash;

    if (value === 'ca-fr') {
      window.location.href = root.dataset.caFrOrigin + path;
      return;
    }

    if (value === 'ca-en') {
      if (current === 'ca-fr') {
        window.location.href = root.dataset.caEnOrigin + path;
        return;
      }

      submitLocalization(root.dataset.caFormId);
      return;
    }

    if (value === 'us-en') {
      if (current === 'ca-fr') {
        sessionStorage.setItem(PENDING_MARKET_KEY, 'US');
        window.location.href = root.dataset.caEnOrigin + path;
        return;
      }

      submitLocalization(root.dataset.usFormId);
    }
  }

  function applyPendingMarketSwitch() {
    const pending = sessionStorage.getItem(PENDING_MARKET_KEY);
    if (!pending) return;

    sessionStorage.removeItem(PENDING_MARKET_KEY);

    const form = document.querySelector(
      pending === 'US'
        ? '.market-language-selector__form [name="country_code"][value="US"]'
        : '.market-language-selector__form [name="country_code"][value="CA"]'
    );

    form?.closest('form')?.submit();
  }

  function closeAllMarketLanguageSelects(except) {
    document.querySelectorAll('market-language-select').forEach((root) => {
      if (root === except) return;
      const trigger = root.querySelector('.market-language-select__trigger');
      const listbox = root.querySelector('.market-language-select__listbox');
      if (!trigger || !listbox) return;
      trigger.setAttribute('aria-expanded', 'false');
      listbox.hidden = true;
      root.classList.remove('is-open');
    });
  }

  function syncFrSubdomainDisplay(root) {
    if (!window.location.hostname.toLowerCase().startsWith('fr.')) return;

    root.dataset.current = 'ca-fr';

    const label = root.querySelector('.market-language-select__label');
    if (label) label.textContent = 'Canada (Français)';

    root.querySelectorAll('.js-market-language-option').forEach((option) => {
      const selected = option.dataset.value === 'ca-fr';
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function initMarketLanguageSelect(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const trigger = root.querySelector('.market-language-select__trigger');
    const listbox = root.querySelector('.market-language-select__listbox');
    const options = root.querySelectorAll('.js-market-language-option');

    if (!trigger || !listbox || !options.length) return;

    syncFrSubdomainDisplay(root);

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = root.classList.contains('is-open');

      closeAllMarketLanguageSelects(root);

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        listbox.hidden = true;
        root.classList.remove('is-open');
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        listbox.hidden = false;
        root.classList.add('is-open');
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        if (!value || value === root.dataset.current) {
          closeAllMarketLanguageSelects();
          return;
        }

        redirectMarketLanguage(root, value);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('market-language-select').forEach(initMarketLanguageSelect);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('market-language-select')) return;
    closeAllMarketLanguageSelects();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllMarketLanguageSelects();
  });

  function init() {
    initAll();
    applyPendingMarketSwitch();
    blockCanadaCommercePages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
